export default __webpack_public_path__ + "static/media/miestrologo.287ec6b0.svg";